// @ts-strict-ignore
import styled from "@emotion/styled";
import { Flex } from "@hubble/web";

import type { DevicesObject } from "utils/common";
import { SimpleCard } from "components/parts/CardSection";

import { mediaQuery } from "@hubble/web";

import { BaseComponentWrapper } from "design-components/baseComponent/BaseComponent.styled";
import { ContentfulButton } from "components/parts/ContentfulButton";

export const StyledGrid = styled(BaseComponentWrapper)`
  display: grid;
  gap: 16px;
  flex-wrap: wrap;
  border-sizing: border-box;
`;

export const CardGridContainer = styled.div`
  max-width: 1128px;
  margin: 0 auto;
  padding: 0 40px;
`;

export const InstitutionsCardGridBackground = styled.div<{
  background?: DevicesObject;
}>`
  background: ${(props) => props?.background.mobile};
`;

export const CardContainer = styled(BaseComponentWrapper)`
  position: relative;
  width: 100%;
  border-radius: 16px;
`;

export const MobileCard = styled(SimpleCard)`
  display: block;
  @media ${mediaQuery.tabletSmUp} {
    display: none;
  }
  @media ${mediaQuery.desktopLgUp} {
    display: none;
  }
`;
export const TabletCard = styled(SimpleCard)`
  display: none;
  @media ${mediaQuery.tabletSmUp} {
    display: block;
  }
  @media ${mediaQuery.desktopLgUp} {
    display: none;
  }
`;
export const DesktopCard = styled(SimpleCard)`
  display: none;
  @media ${mediaQuery.tabletSmUp} {
    display: none;
  }
  @media ${mediaQuery.desktopLgUp} {
    display: block;
  }
`;

export const CardContentWrapper = styled.div`
  height: calc(100% - 40px);
  padding: 20px;
  @media ${mediaQuery.mobileXsDown} {
    height: calc(100% - 8px);
    padding: 4px;
  }
`;

export const GroupedContentWrapper = styled.div`
  margin: 0 auto;
  width: 380px;
  margin-top: 20px;
  padding: 0 20px 20px 20px;
  @media ${mediaQuery.mobileXsDown} {
      width: 100%;
      padding: 0 0px 20px 0px;
      border-top: 0px solid #dadada;
  }
]
`;

export const GroupedContentItemWrapper = styled(Flex)`
  width: 100%;
  border-bottom: 1px solid #dadada;
  height: 60px;
  justify-content: center;
  &:first-child {
    border-top: 1px solid #dadada;
  }
  &:last-child {
    margin-bottom: 40px;
  }
  @media ${mediaQuery.mobileXsDown} {
    justify-content: left;
  }
`;

export const GroupedContentLargeItemWrapper = styled(Flex)`
  border-bottom: 1px solid #dadada;
  padding: 16px 0;
  &:first-child {
    border-top: 1px solid #dadada;
  }
`;

export const StyledButton = styled(ContentfulButton)`
  margin: auto 0 28px 0;
`;
